import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  shiftManagement: {
    generateFromTemplate(studioId, startDate, endDate) {
      let url = buildUrl("plan/generate-from-template")
      return axios.post(url, { studio: studioId, startDate, endDate }, buildOptions()).then((res) => res.data)
    },
    assignEmployeesToPlan(studioId, startDate, endDate, planningSettings, confirmedEmployeeUserIds) {
      let url = buildUrl("shift-management/plan/assign-employees")
      const payload = { studio: studioId, startDate, endDate, planningSettings, confirmedEmployeeUserIds }
      return axios.post(url, payload, buildOptions()).then((res) => res.data)
    },

    generatePlanFromTemplate(studioId, startDate, endDate) {
      let url = buildUrl("plan/generate-from-template")
      const payload = { studio: studioId, startDate, endDate }
      return axios.post(url, payload, buildOptions()).then((res) => res.data)
    },
    fetchWeeklyTemplate(studioId) {
      let url = buildUrl(`shift-management/template/weekly/${studioId}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    saveWeeklyTemplate(studioId, templateData) {
      let url = buildUrl(`shift-management/template/weekly/${studioId}`)
      return axios.put(url, { template: templateData }, buildOptions()).then((res) => res.data)
    },
    fetchSettings(studioId) {
      let url = buildUrl("shift-management/settings/fetch/" + studioId)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    updateEmployeePlanningSettings(employeeId, settings) {
      let url = buildUrl(`employee/website/planning-settings/${employeeId}`)
      return axios.put(url, settings, buildOptions()).then((res) => res.data)
    },
    createOrUpdateSettings(data) {
      let url = buildUrl("shift-management/settings/create-or-update")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },

    fetchShiftManagementCheckinData() {
      let url = buildUrl("shift-management/checkin/data")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    fetchAllHolidayEntries() {
      let url = buildUrl("timetracker/holidays/all")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    fetchShiftManagementEmployee() {
      let url = buildUrl("shift-management/employee/data")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    createShiftPlanEntry(data) {
      let url = buildUrl("shift-management/plan/create")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },

    fetchShiftPlans(studioId, startDate, endDate) {
      let url = buildUrl(`shift-management/plan/fetch/${studioId}/${startDate}/${endDate}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    deleteShiftPlanEntry(id) {
      let url = buildUrl(`shift-management/plan/delete/${id}`)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },
  },
}
